import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';
import React from 'react';

type Props = {
  readonly isOpen: boolean;
  readonly deploymentId: string;
  readonly onConfirmClick: () => void;
  readonly onCancelClick: () => void;
};

const DeploymentRerunDialog = (props: Props) => {
  const {
    isOpen,
    deploymentId,
    onCancelClick,
    onConfirmClick,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onCancelClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
      Rerun deployment
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to rerun deployment with id <strong>{deploymentId}</strong> ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick} color='inherit'>Cancel</Button>
        <Button startIcon={<ReplayIcon />} color='primary' onClick={onConfirmClick}>
          Rerun deployment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeploymentRerunDialog;
